/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Tax_Pending_CodeInputs */

const vi_einvoice_tax_pending_code = /** @type {(inputs: Einvoice_Tax_Pending_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang chờ cơ quan thuế cấp mã`)
};

/**

* @param {Einvoice_Tax_Pending_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_tax_pending_code = /** @type {((inputs?: Einvoice_Tax_Pending_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Tax_Pending_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_tax_pending_code(inputs)
});